import { useCallback } from "react";
import { mediaApi } from "../../../api/aws";


/* =========================
   MEDIA HOOK
========================= */

export default function useMedia() {

  /* =========================
     STORAGE
  ========================= */

  const loadStorage =
    useCallback(

      async () => {

        const {
          data
        } =
          await mediaApi
            .getStorage();
        return (
          data ||
          null
        );

      },

      []

    );

  /* =========================
     MEDIA LIST
  ========================= */

 const loadMedia =
    useCallback(

        async (
            filters = {}
        ) => {

            const {

                data

            } = await mediaApi.getMedia(
                filters
            );
        
            return {

                rows:
                    data?.rows || [],

                pagination:
                    data?.pagination || null

            };

        },

        []

    );

  /* =========================
     UPLOAD
  ========================= */

  const uploadMedia =
    useCallback(

      async (
        formData
      ) => {
  // console.log(formData)
        const {
          data
        } =
          await mediaApi
            .uploadMedia(
              formData
            );
  
        return (
          data?.data
        );

      },

      []

    );

  /* =========================
     DELETE
  ========================= */

  const deleteMedia =
    useCallback(

      async (
        mediaId
      ) => {

        const {
          data
        } =
          await mediaApi
            .deleteMedia(
              mediaId
            );

        return (
          data?.data
        );

      },

      []

    );



  const loadMediaById =
    useCallback(

      async (
        mediaId
      ) => {

        const {
          data
        } =
          await mediaApi
            .loadMediaById(
              mediaId
            );
        return (
          data
        );

      },

      []

    );
  /* =========================
     RESTORE
  ========================= */

  const restoreMedia =
    useCallback(

      async (
        mediaId
      ) => {

        const {
          data
        } =
          await mediaApi
            .restoreMedia(
              mediaId
            );

        return (
          data?.data
        );

      },

      []

    );

  /* =========================
     MEDIA URL
  ========================= */

  const getMediaUrl =
    useCallback(

      async (
        mediaId
      ) => {

        const {
          data
        } =
          await mediaApi
            .getMediaUrl(
              mediaId
            );

        return (
          data?.data
        );

      },

      []

    );
const bulkDelete =
    useCallback(

        async payload => {

            const {

                data

            } =

            await mediaApi
                .bulkDeleteMedia(
                    payload
                );

            return data.data;

        },

        []

    );
  return {

    loadStorage,

    loadMedia,
    loadMediaById,
    uploadMedia,

    deleteMedia,

    restoreMedia,

    getMediaUrl,bulkDelete

  };

}